import {ArrowLeftIcon} from '../../icons'
import {IconButton} from '../button'
import {useDrawerContext} from './context'
import {classes} from './MobileDrawer.classes'

type CloseButtonProps = {
  onClose?: VoidFunction
}

export const CloseButton = ({onClose: onCloseProp}: CloseButtonProps) => {
  const {onClose} = useDrawerContext()

  return (
    <IconButton className={classes.backBtn} onClick={onCloseProp || onClose} shape="circle">
      <ArrowLeftIcon />
    </IconButton>
  )
}
